/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=d6dfa7ba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d6dfa7ba&lang=scss"

import exportComponent from "/var/workhome/jenkins/jenkins_home/workspace/prod-vue-mt-comp-sso/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__